( function( $ ) {

    $(document).ready( function() {

        if ( $('.wp-block-st-main-nav').length > 0 ) {

            // Set nav columns
            $('.wp-block-st-main-nav .wp-block-navigation__container').each( function() {
                let count = $(this).children('li').length;
                if ( count > 3 ) {
                    $(this).addClass('two-cols');
                }
            });
            // Set megamenu height
            $(window).bind('load resize', function() {
                $('.subnav-megamenu').each(function() {
                    let height = $(this).children().outerHeight() + 'px';
                    $(this).css('--body-height', height);
                });
            });

            // Trigger megamenu
            $('.megamenu-toggle').on( 'click', function( e ) {
               e.preventDefault(); 

               let $this = $(this);

               if ($this.parent('.wp-block-st-main-nav__nav-item').hasClass('is-active')) {
                $this.closest('.site-header').removeClass('menu-active');
                   $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
               } else {
                   $('.wp-block-st-main-nav__nav-item').removeClass('is-active');

                   if ($this.closest('.site-header').hasClass('menu-active')) {
                    window.setTimeout(function() {
                        $this.parent('.wp-block-st-main-nav__nav-item').toggleClass('is-active');
                    }, 600);
                    
                   } else {
                    $this.parent('.wp-block-st-main-nav__nav-item').toggleClass('is-active');
                   }
                   $this.closest('.site-header').addClass('menu-active');
                   
               }
               
            });

            $('.wp-block-st-main-nav__button-open').on( 'click', function( e ) {
                e.preventDefault();
                $( 'html' ).toggleClass( 'toggle-main-nav' );
                
            });

            // Close megamenu if anywhere outside is clicked or if an on page link is clicked.
            $(document).on( 'click', function( e ) {
                if ( !$( e.target ).closest( '.wp-block-st-main-nav' ).length ) {
                    $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
                    $('.site-header').removeClass('menu-active');
                }
            });

            // Close megamenu if an on page link is clicked.
            $('.wp-block-st-main-nav__subnav a').on( 'click', function( e ) {
                $('.wp-block-st-main-nav__nav-item').removeClass('is-active');
                $('.site-header').removeClass('menu-active');
            });
            

        }


    } );

} )( jQuery );
